import { render } from "./DataExtDoc.vue?vue&type=template&id=e0830018"
import script from "./DataExtDoc.vue?vue&type=script&lang=js"
export * from "./DataExtDoc.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/bezbedno/admin/static/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"js/Pages/DataExtDoc.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e0830018"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e0830018', __exports__)) {
    console.log('reload')
    api.reload('e0830018', __exports__)
  }
  
  module.hot.accept("./DataExtDoc.vue?vue&type=template&id=e0830018", () => {
    console.log('re-render')
    api.rerender('e0830018', render)
  })

}


export default __exports__